import React from 'react';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Skeleton from '@material-ui/lab/Skeleton';
import { stylePropType } from 'utils/propTypes';

const ResultPromoTitle = ({ title, isLoading, style }) => {
    return (
        <div css={[titleContainerStyle, style]}>
            <Typography variant="h6">
                {isLoading ? <Skeleton animation="wave" css={css(`width: 150px;`)} /> : title}
            </Typography>
        </div>
    );
};

export default ResultPromoTitle;

ResultPromoTitle.propTypes = {
    title: PropTypes.string.isRequired,
    isLoading: PropTypes.bool,
    style: stylePropType
};

const titleContainerStyle = css`
    padding-bottom: 8px;
    > * {
        color: inherit;
    }
`;
